import type { RaceOverview, SessionProcess, SessionResult } from '../../shared/overview';

export function processIdentity(result: SessionResult | null | undefined): string | null {
  return result?.process && result.process.eventCount > 0 ? `${result.session.key}:${result.process.version}` : null;
}

export function matchesProcess(result: SessionResult | null, process: SessionProcess | null): boolean {
  return !!result?.process && !!process && result.session.key === process.sessionKey
    && result.process.version === process.version && result.process.eventCount === process.events.length;
}

/** New lightweight summaries retain only events from the same session and exact content revision. */
export function mergeOverviewProcess(overview: RaceOverview, process: SessionProcess | null): RaceOverview {
  if (!matchesProcess(overview.result, process)) return overview;
  return { ...overview, result: { ...overview.result!, events: process!.events } };
}
